module.exports = __webpack_public_path__ + "img/logo_vivo_ligado_amarelo_branco.6dc2005d.png";